import React, {useState} from 'react';
import {Button, Form, Stack} from 'react-bootstrap';
import {Box, DI, FirebaseService, Loading} from "shared-lib";
import {useNavigate} from "react-router-dom";
import {AuthConst} from "@consts";
import {useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";

const firebaseService: FirebaseService = DI.get(FirebaseService);
type States = { inProgress: boolean };

export function SignUpPage(): React.ReactElement {
    const navigate = useNavigate();
    const {register, handleSubmit, getValues, formState: {errors}} = useForm();
    const {t} = useTranslation();
    const [states, setStates] = useState({} as States);

    const onSubmit = ({email, password, phoneNumber}) => {
        setStates({...states, inProgress: true});
        firebaseService.createUser(email, password)
            .then(userCredential => {
                navigate(AuthConst.PHONE_NUMBER_VERIFICATION_PAGE, {replace: true, state: {phoneNumber}});
            });
    }

    return (
        <Stack className="login-page min-vh-100 justify-content-center align-items-center bg-dark">
            <img className="login-page__logo mb-4" src="./logo_440x64.png"/>
            <Box className="login-page__form">
                <Loading show={states.inProgress}/>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Form.Group className="mb-3">
                        <Form.Control
                            size="lg"
                            type="email"
                            placeholder={t('common.input.placeholder.email')}
                            isInvalid={!!errors.email}
                            {...register("email", {required: true})}
                        />
                        <Form.Control.Feedback type="invalid" className="text-center">
                            {t('common.input.required')}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Control
                            size="lg"
                            type="password"
                            placeholder={t('common.input.placeholder.password')}
                            isInvalid={!!errors.password}
                            {...register("password", {required: true, min: 6})}
                        />
                        <Form.Control.Feedback type="invalid">
                            {t('common.input.required')}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Control
                            size="lg"
                            type="password"
                            placeholder={t('common.input.placeholder.confirmPassword')}
                            isInvalid={!!errors.confirmPassword}
                            {...register("confirmPassword", {
                                required: t('common.input.required'),
                                validate: (val: string) => {
                                    const {password} = getValues();
                                    if (password != val) {
                                        return t('common.input.password.notMatchedPassword');
                                    }
                                }
                            })}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.confirmPassword?.message}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Control
                            size="lg"
                            type="text"
                            placeholder={t('common.input.placeholder.phoneNumber')}
                            isInvalid={!!errors.phoneNumber}
                            {...register("phoneNumber", {
                                required: t('common.input.required'),
                                pattern: {
                                    value: /^05[0-9]{9}$/,
                                    message: t('common.input.phone.notMatchedPattern')
                                }
                            })}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.phoneNumber?.message}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Button variant="primary" type="submit"
                            className="w-100 btn-lg">{t('signUp.createUser.submit')}</Button>
                </Form>
            </Box>
        </Stack>
    );
}
